import SlButtonGroup from '@shoelace-style/shoelace/dist/react/button-group/index.js';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import '@shoelace-style/shoelace/dist/themes/light.css'
import './ResultsPagination.css'

export default function ResultPagination({ pageData, onPageChange }) {
    console.log("pagination data:", pageData);
    const totalPages = Math.ceil(pageData.total / pageData.pageSize);
    const pages = [];
    const start = Math.max(1, pageData.page - 2);
    const end = Math.min(totalPages, pageData.page + 2);

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }
    return (
        <div className="pagination-container">
            <SlButtonGroup label="Pagination">
                <SlButton
                    size="medium"
                    variant="secondary"
                    disabled={pageData.page === 1}
                    onClick={() => onPageChange(pageData.page - 1)}
                >
                    Prev
                </SlButton>
                {start > 1 && (
                    <>
                        <SlButton
                            size="medium"
                            variant="secondary"
                            onClick={() => onPageChange(1)}
                        >
                            1
                        </SlButton>
                        {start > 2 && (
                            <SlButton
                                size="medium"
                                variant="secondary"
                                disabled
                            >
                                ...
                            </SlButton>
                        )}
                    </>
                )}
                {pages.map((item)=>(
                    <SlButton
                    key={item}
                            size="medium"
                            variant={item === pageData.page ? "primary" : "secondary"}
                            onClick={() => onPageChange(item)}
                        >
                            {item}
                        </SlButton>
                ))}
                {end < totalPages && (
                    <>
                        {end < totalPages - 1 &&(
                            <SlButton
                            size="medium"
                            disabled
                        >
                            ...
                        </SlButton>
                        )}
                        <SlButton
                            size="medium"
                            variant="secondary"
                            onClick={() => onPageChange(totalPages)}
                        >
                            {totalPages}
                        </SlButton>
                    </>
                )}
                <SlButton
                            size="medium"
                            variant="secondary"
                            disabled={pageData.page === totalPages}
                            onClick={() => onPageChange(pageData.page + 1)}
                        >
                            Next
                        </SlButton>
            </SlButtonGroup>
        </div>
    )
}